export enum AnalyticsReportEmployeeScope {
  AllEmployees = 'ALL_EMPLOYEES',
}

export enum AnalyticsReportTypes {
  Company = 'company',
  Unit = 'unit',
  Team = 'team',
  HR = 'hr',
  LegalEntity = 'legent',
}

export enum AnalyticsReportRoleScope {
  Manager = 'manager',
  AltManager = 'amgr',
  DeputyManager = 'dmgr',
}

export enum AnalyticsReportScope {
  All = 'all',
  Direct = 'direct',
}

export type AnalyticsReportTypeCompany = {
  type: AnalyticsReportTypes.Company;
};

export type AnalyticsReportTypeUnit = {
  type: AnalyticsReportTypes.Unit;
  unitId: number;
  scope: AnalyticsReportScope;
};

export type AnalyticsReportTypeTeam = {
  type: AnalyticsReportTypes.Team;
  role: AnalyticsReportRoleScope;
  employeeId: number;
  scope: AnalyticsReportScope;
};

export type AnalyticsReportTypeHR = {
  type: AnalyticsReportTypes.HR;
  role: AnalyticsReportRoleScope;
  employeeId: number;
  scope: AnalyticsReportScope;
};

export type AnalyticsReportTypeLegalEntity = {
  type: AnalyticsReportTypes.LegalEntity;
  legalEntityId: number;
  scope: AnalyticsReportScope;
};

export type AnalyticsReportTypeConfig =
  | AnalyticsReportTypeCompany
  | AnalyticsReportTypeUnit
  | AnalyticsReportTypeTeam
  | AnalyticsReportTypeHR
  | AnalyticsReportTypeLegalEntity;

export type AnalyticsReportTypeSettingsConfig = Omit<
  AnalyticsReportTypeCompany,
  'type'
> &
  Omit<AnalyticsReportTypeUnit, 'type'> &
  Omit<AnalyticsReportTypeTeam, 'type'> &
  Omit<AnalyticsReportTypeHR, 'type'> &
  Omit<AnalyticsReportTypeLegalEntity, 'type'> & {
    type: AnalyticsReportTypes;
  };

export type AnalyticsReportParams<CustomParams> = {
  startDate?: Date;
  endDate?: Date;
  empScope?: AnalyticsReportEmployeeScope;
} & CustomParams;

export type AnalyticsReportProps<CustomParams> = {
  reportType: AnalyticsReportTypeConfig;
  params?: AnalyticsReportParams<CustomParams>;
  reportDisabled?: boolean;
};

export type AnalyticsReportSettingsProps<CustomParams> = {
  reportType: AnalyticsReportTypeSettingsConfig;
  params?: AnalyticsReportParams<CustomParams>;
};

export type AnalyticsReportDefaultProps<CustomParams> = {
  reportType: Partial<AnalyticsReportTypeSettingsConfig>;
  params?: AnalyticsReportParams<CustomParams>;
};
